import { HTTP_METHODS } from '../../constants/HttpConstants';
import { sendRequestToServerWithCredentials } from '../../utils/request';

export const getTechnologiesApi = () =>
  sendRequestToServerWithCredentials({
    method: HTTP_METHODS.GET,
    url: '/interviews/technology/list/',
  });
